import { Box, Collapse, IconButton, makeStyles, TableCell, TableRow, Typography } from "@material-ui/core";
import Highcharts from "highcharts";
import { useState } from "react";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import ArrowAnimationIcon from "src/components/Icon/ArrowAnimationIcon";
import { EXPLORER_TYPE } from "src/hooks/useExplorerUrl";
import { formatAddress, numberWithCommas, toFixed } from "src/services/utils";

export const useStyle = makeStyles(() => ({
  collapseBox: {
    padding: "0.5rem",
  },
  collapseTitle: {
    fontSize: "14px",
    fontWeight: 400,
  },
}));

export default function SmallTransactionRow({ rowData, pool, isFullTable = true }) {
  const cls = useStyle();
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell colSpan={2}>
          <Typography>{rowData.type}</Typography>
        </TableCell>
        <TableCell colSpan={3}>
          <Typography>{Highcharts.dateFormat("%b %e, %Y, %k:%M", rowData.timestamp)}</Typography>
        </TableCell>
        <TableCell colSpan={2}>
          <Typography>{`$${numberWithCommas(toFixed(rowData.amount, 2))}`}</Typography>
        </TableCell>
        {isFullTable && (
          <TableCell colSpan={1}>
            <IconButton onClick={() => setOpen(!open)}>
              <ArrowAnimationIcon isTransform={open} />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      {isFullTable && (
        <TableRow>
          <TableCell colSpan={8} style={{ padding: 0 }}>
            <Collapse in={open}>
              <Box display="flex" justifyContent="space-between" className={cls.collapseBox}>
                <Box display="flex" flexDirection="column" justifyContent="flex-start">
                  <Typography className={cls.collapseTitle}>Token</Typography>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography>{rowData.symbol}</Typography>
                    <ExternalLinkButton hash={rowData.token} config={{ pool }} />
                  </Box>
                </Box>
                <Box display="flex" flexDirection="column" justifyContent="flex-start">
                  <Typography className={cls.collapseTitle}>Transaction</Typography>
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography>{formatAddress(rowData.transaction, 3)}</Typography>
                    <ExternalLinkButton hash={rowData.transaction} config={{ pool, type: EXPLORER_TYPE.TRANSACTION }} />
                  </Box>
                </Box>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
